/*
 * The shell's script. PORTED from marketing-site src/components/kit/HeaderScript.astro
 * at b894dcb (re-copied for tweak round 1, owner, 7 Oct 2026; first ported at
 * e39348f) with the TypeScript annotations removed and nothing else changed.
 * Header.astro says why there is any script and why it is this little: toggle
 * the overlay (with the open control's aria-expanded), Escape, inert, and hide
 * on scroll (at the end; it acts only on a shell with data-dg-hide-on-scroll,
 * which snippets/dg-header.liquid renders). Hover intent, focus opening the
 * panel and the strip's inversion are CSS reading one attribute. Change it
 * there and re-copy.
 */
(() => {
  const OPEN = 'data-dg-menu-open';
  const DISMISSED = 'data-dg-dismissed';

  function setMenu(shell, open) {
    shell.toggleAttribute(OPEN, open);
    shell.querySelector('[data-dg-menu-toggle="open"]')?.setAttribute('aria-expanded', String(open));
    for (const sibling of shell.parentElement?.children ?? []) {
      if (sibling !== shell && sibling instanceof HTMLElement) sibling.inert = open;
    }
    shell.querySelector(open ? '.dg-menu a' : '[data-dg-menu-toggle="open"]')?.focus();
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest?.('[data-dg-menu-toggle]');
    const shell = toggle?.closest('.dg-shell');
    if (toggle && shell) setMenu(shell, toggle.getAttribute('data-dg-menu-toggle') === 'open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const shell = document.querySelector(`.dg-shell[${OPEN}]`);
    if (shell) setMenu(shell, false);
    const guides = event.target.closest?.('.dg-guides');
    if (guides) {
      guides.setAttribute(DISMISSED, '');
      guides.querySelector('.dg-guides-pill')?.focus();
    }
  });

  for (const guides of document.querySelectorAll('.dg-guides')) {
    const clear = () => guides.removeAttribute(DISMISSED);
    guides.addEventListener('mouseleave', clear);
    guides.addEventListener('focusout', (event) => {
      if (!guides.contains(event.relatedTarget)) clear();
    });
  }

  /**
   * Hide on scroll. Sets data-dg-header-hidden on the shell while the reader
   * is going down. header.css, "The bar", decides whether that hides anything:
   * focus inside the bar, an open guides panel and the open overlay each hold
   * it there, so this never has to know about them and cannot fall out of
   * step with them.
   *
   * HIDE. While the bar is shown, it hides once the page has moved this far
   * down from where the count started, so trackpad jitter or a one-pixel
   * nudge does not flicker it.
   *
   * REVEAL. While the bar is hidden, it returns only after this much
   * continuous upward scroll: any frame that moves down starts the count
   * again. The ruling (27 Sep 2026) is that the header answers a deliberate
   * scroll up, not a reader correcting their place in the text — at 8px a
   * small correction brought it back over the line being read, and at 48px
   * a light flick on a phone still did. 150px is what reads as deliberate.
   *
   * THE TOP OF THE PAGE. Within the bar's own height of the top it is always
   * shown, iOS's negative overscroll included, so it never hides while it
   * still sits in its place above the first section.
   *
   * ONE PASS PER FRAME. The listener is passive and only schedules; the
   * reading and the one attribute write happen together in a single
   * requestAnimationFrame, so a burst of scroll events costs one layout read
   * per frame rather than one per event, and the read never follows a write.
   */
  const HIDDEN = 'data-dg-header-hidden';
  const HIDE = 8;
  const REVEAL = 150;

  for (const shell of document.querySelectorAll('.dg-shell[data-dg-hide-on-scroll]')) {
    const bar = shell.querySelector('.dg-shell__bar');
    if (!bar) continue;
    /* Shown: where the downward count starts. Hidden: where the current
     * upward run started. */
    let anchor = window.scrollY;
    let last = anchor;
    let queued = false;

    const update = () => {
      queued = false;
      const y = window.scrollY;
      if (y <= bar.offsetHeight) {
        shell.removeAttribute(HIDDEN);
        anchor = last = y;
        return;
      }
      if (shell.hasAttribute(HIDDEN)) {
        if (y > last) anchor = y;
        else if (anchor - y >= REVEAL) {
          shell.removeAttribute(HIDDEN);
          anchor = y;
        }
      } else {
        const moved = y - anchor;
        if (Math.abs(moved) >= HIDE) {
          shell.toggleAttribute(HIDDEN, moved > 0);
          anchor = y;
        }
      }
      last = y;
    };

    window.addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }, { passive: true });
  }
})();
